import { apiClient } from './api';
import type {
  ApplicationDefinition,
  CreateApplicationDefinitionRequest,
  UpdateApplicationDefinitionRequest,
} from '../types/applicationDefinition';
import type { CurrentHealthStatus } from '../types/healthCheck';

export interface UnhealthyApplicationItem {
  application: ApplicationDefinition;
  currentStatus: CurrentHealthStatus;
}

export const applicationDefinitionService = {
  getAll: async (tenantId?: string, serverId?: string): Promise<ApplicationDefinition[]> => {
    const params = new URLSearchParams();
    if (tenantId) params.append('tenantId', tenantId);
    if (serverId) params.append('serverId', serverId);

    const response = await apiClient.get<ApplicationDefinition[]>(
      `/ApplicationDefinitions${params.toString() ? `?${params.toString()}` : ''}`
    );
    return response.data;
  },

  getUnhealthy: async (limit = 10): Promise<UnhealthyApplicationItem[]> => {
    const response = await apiClient.get<UnhealthyApplicationItem[]>(
      `/ApplicationDefinitions/unhealthy?limit=${limit}`
    );
    return response.data;
  },

  getById: async (id: string): Promise<ApplicationDefinition> => {
    const response = await apiClient.get<ApplicationDefinition>(`/ApplicationDefinitions/${id}`);
    return response.data;
  },

  create: async (data: CreateApplicationDefinitionRequest): Promise<string> => {
    const response = await apiClient.post<string>('/ApplicationDefinitions', data);
    return response.data;
  },

  update: async (data: UpdateApplicationDefinitionRequest): Promise<void> => {
    await apiClient.put(`/ApplicationDefinitions/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/ApplicationDefinitions/${id}`);
  },
};











